import type React from 'react';
import { Button } from '@oysterjs/ui/button';

const CONTACT_SALES_URL = 'https://meetings.hubspot.com/vic-yeh';

/**
 * Shown instead of a settings page whose feature needs the Enterprise plan, so
 * an admin who opens it learns what the feature does and how to get it, and
 * anyone else who reaches it learns whom to ask.
 */
export const EnterpriseUpgradeNotice = ({
  title,
  icon: Icon,
  heading,
  documentationUrl,
  canContactSales = true,
  children
}: {
  title: string;
  icon: React.ComponentType<{ className?: string }>;
  heading: string;
  documentationUrl: string;
  /**
   * False for a reader who cannot act on Contact Sales, who is sent to an
   * agency admin instead.
   */
  canContactSales?: boolean;
  children: React.ReactNode;
}) => (
  <div className="divide-y divide-neutral-200 dark:divide-neutral-700 rounded-lg bg-white dark:bg-neutral-800 shadow">
    <div className="px-4 py-5 sm:px-6">
      <h3 className="m-0 p-0 text-lg font-medium text-neutral-900 dark:text-white">{title}</h3>
    </div>
    <div className="px-4 py-5 sm:px-6">
      <div className="text-center">
        <Icon className="mx-auto size-12 text-neutral-400 dark:text-neutral-500" />
        <h3 className="mt-2 text-sm font-semibold text-neutral-900 dark:text-white">{heading}</h3>
        <p className="mx-auto mt-1 max-w-2xl text-sm text-neutral-500 dark:text-neutral-400">
          {children}
        </p>
        {canContactSales ? null : (
          <p className="mx-auto mt-2 max-w-2xl text-sm text-neutral-500 dark:text-neutral-400">
            Ask an agency admin about the Enterprise plan.
          </p>
        )}
      </div>
      <div className="mt-6 flex flex-wrap justify-center gap-2">
        {canContactSales ? (
          <Button color="sky" href={CONTACT_SALES_URL} target="_blank">
            Contact Sales
          </Button>
        ) : null}
        <Button color="white" href={documentationUrl} target="_blank">
          View Documentation
        </Button>
      </div>
    </div>
  </div>
);
